module.exports = __webpack_public_path__ + "img/avatar-3.dc7ffd21.png";